<template>
  <CertificatePage :page="page" :list="list" :stats="stats" />
</template>

<script>
import CertificatePage from '../components/CertificatePage';

export default {
  components: {
    CertificatePage,
  },
  async asyncData({ $axios, route, $config }) {
    const { modules, courses, upcoming } = await $axios.$get('/courses');
    const [page, stats] = await Promise.all([
      $axios.$get(`/pages/${route.fullPath}`).catch(() => false),
      $axios.$get('/stats/courses?reduced=1').catch(() => false),
    ]);
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();
    return { page, list: { modules, courses, upcoming }, stats };
  },
};
</script>
